import { render, staticRenderFns } from "./AddCohortCardImage.vue?vue&type=template&id=9567290e"
import script from "./AddCohortCardImage.vue?vue&type=script&lang=js"
export * from "./AddCohortCardImage.vue?vue&type=script&lang=js"
import style0 from "./AddCohortCardImage.vue?vue&type=style&index=0&id=9567290e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports